const root = document.querySelector('[data-gl-recently-viewed]');
const grid = root && root.querySelector('[data-gl-recently-viewed-grid]');

const hide = () => {
  if (root) root.remove();
};

const previouslyViewedIds = () => {
  const currentId = String(root.dataset.productId || '');

  try {
    const stored = JSON.parse(localStorage.getItem('viewedProducts') || '[]');
    if (!Array.isArray(stored)) return [];
    return stored.map(String).filter((id) => id && id !== currentId);
  } catch (error) {
    return [];
  }
};

const cardForHandle = async (handle) => {
  const response = await fetch(`/products/${encodeURIComponent(handle)}?view=gl-card`);
  if (!response.ok) return null;
  const html = await response.text();
  const parsed = new DOMParser().parseFromString(html, 'text/html');
  return parsed.querySelector('[data-gl-gear-card] product-card');
};

const mount = async () => {
  if (!root || !grid) return;

  const ids = previouslyViewedIds();
  if (!ids.length) {
    hide();
    return;
  }

  try {
    const query = ids.map((id) => `id:${id}`).join(' OR ');
    const searchUrl = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=${ids.length}&resources[options][unavailable_products]=last`;
    const response = await fetch(searchUrl);
    if (!response.ok) throw new Error('recently viewed lookup failed');

    const payload = await response.json();
    const products = (payload.resources && payload.resources.results && payload.resources.results.products) || [];
    const byId = new Map(products.map((product) => [String(product.id), product]));
    const ordered = ids.map((id) => byId.get(id)).filter((product) => product && product.handle);

    const cards = await Promise.all(ordered.map((product) => cardForHandle(product.handle)));
    cards.forEach((card) => {
      if (!card) return;
      const item = document.createElement('div');
      item.className = 'resource-list__item';
      item.appendChild(document.importNode(card, true));
      grid.appendChild(item);
    });

    if (!grid.children.length) {
      hide();
      return;
    }

    root.hidden = false;
  } catch (error) {
    hide();
  }
};

mount();
